function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var RefreshTimeout = /*#__PURE__*/function (RefreshTimeout) {
  RefreshTimeout[RefreshTimeout["FIVE_SECONDS"] = 5000] = "FIVE_SECONDS";
  RefreshTimeout[RefreshTimeout["TEN_SECONDS"] = 10000] = "TEN_SECONDS";
  RefreshTimeout[RefreshTimeout["FIFTEEN_SECONDS"] = 15000] = "FIFTEEN_SECONDS";
  RefreshTimeout[RefreshTimeout["THIRTY_SECONDS"] = 30000] = "THIRTY_SECONDS";
  RefreshTimeout[RefreshTimeout["ONE_MINUTE"] = 60000] = "ONE_MINUTE";
  RefreshTimeout[RefreshTimeout["FIVE_MINUTES"] = 300000] = "FIVE_MINUTES";
  RefreshTimeout[RefreshTimeout["TEN_MINUTES"] = 600000] = "TEN_MINUTES";
  RefreshTimeout[RefreshTimeout["FIFTEEN_MINUTES"] = 900000] = "FIFTEEN_MINUTES";
  return RefreshTimeout;
}({});
var refreshTimeoutInfoMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RefreshTimeout.FIVE_SECONDS, {
  label: '5s',
  seconds: 5
}), RefreshTimeout.TEN_SECONDS, {
  label: '10s',
  seconds: 10
}), RefreshTimeout.FIFTEEN_SECONDS, {
  label: '15s',
  seconds: 15
}), RefreshTimeout.THIRTY_SECONDS, {
  label: '30s',
  seconds: 30
}), RefreshTimeout.ONE_MINUTE, {
  label: '1m',
  seconds: 60
}), RefreshTimeout.FIVE_MINUTES, {
  label: '5m',
  seconds: 300
}), RefreshTimeout.TEN_MINUTES, {
  label: '10m',
  seconds: 600
}), RefreshTimeout.FIFTEEN_MINUTES, {
  label: '15m',
  seconds: 900
});

// tslint:disable-next-line:no-namespace
(function (_RefreshTimeout) {
  function getKeys() {
    return Object.keys(RefreshTimeout).filter(function (ch) {
      return typeof RefreshTimeout[ch] === 'string';
    });
  }
  _RefreshTimeout.getKeys = getKeys;
  function getAll() {
    var timeouts = RefreshTimeout.getKeys().map(function (key) {
      return RefreshTimeout[key];
    });
    timeouts.sort();
    return timeouts;
  }
  _RefreshTimeout.getAll = getAll;
  function getLabel(value) {
    return refreshTimeoutInfoMap[value].label;
  }
  _RefreshTimeout.getLabel = getLabel;
})(RefreshTimeout || (RefreshTimeout = {}));